An array of application method identifiers.

If no methods are provided, SEEK's Apply Form will be used to receive candidate applications.
